import React from 'react';
import PropTypes from 'prop-types';
import Styled from './table-checkbox-style';

/**
 * Checkbox component for generic use in project.
 * @param {object} props - The component props.
 * @param {string} props.width - Width of the checkbox.
 * @param {string} props.margin - Margin of the checkbox.
 * @param {string} props.label - Label for the checkbox.
 * @param {boolean} props.value - Value of the checkbox.
 * @param {string} props.name - Name of the checkbox.
 * @param {Function} props.onChange - Function to call when the checkbox is changed.
 * @param {object} props.style - object style
 * @param {string} props.color - color
 * @param {string} props.textColor - text color
 * @returns {JSX.Element}
 */
const Checkbox = ({
  width,
  margin,
  label,
  value,
  name,
  onChange,
  style,
  color,
  textColor,
}) => (
  <Styled.Container
    width={width}
    margin={margin}
    style={style}
    textColor={textColor}
  >
    {label}
    <Styled.CheckBox
      type="checkbox"
      defaultChecked={value}
      onChange={onChange}
      color={color}
      name={name}
    />
    <Styled.CheckMark className="checkMark" />
  </Styled.Container>
);

Checkbox.defaultProps = {
  width: '',
  name: '',
  margin: '',
  color: '',
  textColor: '',
  value: undefined,
  style: {},
  onChange: undefined,
};

Checkbox.propTypes = {
  width: PropTypes.string,
  margin: PropTypes.string,
  label: PropTypes.string.isRequired,
  value: PropTypes.bool,
  color: PropTypes.string,
  textColor: PropTypes.string,
  onChange: PropTypes.func,
  style: PropTypes.object,
  name: PropTypes.string,
};

export default Checkbox;
